// ChefRepository.js
class ChefRepository {
    constructor() {
        // Base URL for your API - change this to your deployed server URL
        //this.apiUrl = 'http://147.93.95.186:5000/api'; // Default for local development
        this.apiUrl = 'https://server.unitesainteveronique.com/api'; // Default for local development
    }

    // Set the API URL (useful for different environments)
    setApiUrl(url) {
        this.apiUrl = url;
    }

    async getChefsBySectionId(idSection) {
        try {
            const response = await fetch(`${this.apiUrl}/chefs/section/${idSection}`);
            if (!response.ok) {
                throw new Error(`Failed to fetch chefs: ${response.statusText}`);
            }
            return await response.json();
        } catch (error) {
            console.error('Error fetching chefs by section ID:', error);
            throw error;
        }
    }

    async getChefById(id) {
        try {
            const response = await fetch(`${this.apiUrl}/chefs/${id}`);
            if (!response.ok) {
                throw new Error(`Failed to fetch chef: ${response.statusText}`);
            }
            const data = await response.json();
            return data;
        } catch (error) {
            console.error('Error fetching chef by ID:', error);
            throw error;
        }
    }

    async updateChef(id, updatedChef) {
        // Create a FormData object to handle file uploads
        const formData = new FormData();

        // Add text fields
        formData.append('nom', updatedChef.nom);
        formData.append('etudes', updatedChef.etudes);
        formData.append('annee_arrivee', updatedChef.annee_arrivee);
        formData.append('contact', updatedChef.contact);
        formData.append('role', updatedChef.role);
        formData.append('age', updatedChef.age);

        // Handle photo upload
        if (updatedChef.photo instanceof File) {
            formData.append('photo', updatedChef.photo);
        } else if (updatedChef.photo) {
            formData.append('photoUrl', updatedChef.photo);
        }

        try {
            const response = await fetch(`${this.apiUrl}/chefs/${id}`, {
                method: 'PUT',
                body: formData,
                // Don't set Content-Type header when using FormData
            });

            if (!response.ok) {
                throw new Error(`Failed to update chef: ${response.statusText}`);
            }

            return await response.json();
        } catch (error) {
            console.error('Error updating chef:', error);
            throw error;
        }
    }

    async createChef(sectionId) {
        try {
            const response = await fetch(`${this.apiUrl}/chefs`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    nom: "José",
                    etudes: "Mascotte",
                    annee_arrivee: "1930",
                    contact: "04444444444",
                    role: "Mascotte",
                    photo: "",
                    age: "Bientot 100 ans",
                    id_1: sectionId
                }),
            });

            if (!response.ok) {
                throw new Error(`Failed to create chef: ${response.statusText}`);
            }

            const result = await response.json();
            return result.insertId;
        } catch (error) {
            console.error('Error creating chef:', error);
            throw error;
        }
    }

    async suppressChef(id) {
        try {
            const response = await fetch(`${this.apiUrl}/chefs/${id}`, {
                method: 'DELETE',
            });

            if (!response.ok) {
                throw new Error(`Failed to delete chef: ${response.statusText}`);
            }

            return await response.json();
        } catch (error) {
            console.error('Error deleting chef:', error);
            throw error;
        }
    }
}

export default ChefRepository;